// Class
import { SmartTagBase } from './smartTagBase';
// Model
import { SmartTagModel } from './smartTag.model';

export class SmartTagUpdateTypeModel extends SmartTagModel {
	updateType?: string;
	timeframe?: string;

	constructor() {
		super();

		this.updateType = '';
		this.timeframe = '';
	}
}

export class SmartTagUpdateType extends SmartTagBase {

	/**
	 * Renderer
	 * @param data SmartTagUpdateModel
	 */
	public render(data: SmartTagUpdateTypeModel, version?: string): string {
		this.getData(data);

		return this.getOutputData(version || 'v1');
	}

	private getData(data: SmartTagUpdateTypeModel): void{
		const title = data.title || data.subCategory || '';
		const timeframe = data.timeframe || '';
		const updateType = data.updateType?.trim() || '';
		const description = data.description?.trim() || '';

		if (title !== '') {
			this.title = `<span title="${title}">Type: ${title}</span>`;
		}

		if (timeframe !== '') {
			this.addText(`<span title="${timeframe}">Timeframe: ${timeframe}</span>`);
		}

		if (updateType !== '') {
			this.addText(`<span title="${updateType}">Update type: ${updateType}</span>`);
		}

		if (description !== '') {
			this.addText(`<span title="${description}">Description: ${description}</span>`);
		}
	}
}
